import { baseSepolia } from "viem/chains";

/** App runs on test networks only for this MVP. */
export const NETWORK = "devnet" as const;

export const SOLANA_CLUSTER = "devnet" as const;
export const SOLANA_CAIP = "solana:devnet" as const;

export const SOLANA_HTTP =
  (import.meta.env.VITE_SOLANA_RPC as string | undefined) ||
  "https://api.devnet.solana.com";

export const SOLANA_WS =
  (import.meta.env.VITE_SOLANA_WS as string | undefined) ||
  "wss://api.devnet.solana.com";

export const SOLANA_EXPLORER = "https://explorer.solana.com";
export const solscanTx = (sig: string) =>
  `${SOLANA_EXPLORER}/tx/${sig}?cluster=devnet`;
export const solscanAddr = (addr: string) =>
  `${SOLANA_EXPLORER}/address/${addr}?cluster=devnet`;

/** EVM testnet companion to Solana devnet */
export const EVM_CHAIN = baseSepolia;
export const EVM_RPC =
  (import.meta.env.VITE_EVM_RPC as string | undefined) ||
  "https://sepolia.base.org";

export const EVM_EXPLORER = "https://sepolia.basescan.org";
export const basescanTx = (hash: string) => `${EVM_EXPLORER}/tx/${hash}`;
export const basescanAddr = (addr: string) => `${EVM_EXPLORER}/address/${addr}`;

export const SOL_FAUCET = "https://faucet.solana.com";
export const BASE_SEPOLIA_FAUCET = "https://www.alchemy.com/faucets/base-sepolia";
